
/* global $ */
import {   initVideoListener } from "@api/utils_2020";
import PhotoSwipe from "photoswipe";
import PhotoSwipeUI_Default from "photoswipe/dist/photoswipe-ui-default";
window.escTip = false;

export default () => {
    console.log('init reportCersaie');
   initVideoListener();
   
   function initGallery(galleryNumber, photoIndex) {

        const pswpElement = document.querySelectorAll(".pswp")[0];

        const photos = [...document.querySelectorAll("img.catalogPage"+galleryNumber)].map((photo, index) => {
            if (photo.dataset.type == 'video')
            {
                var videoSrc = photo.dataset.src;
                return {
                    html: '<div class="video"><iframe width="390" height="847" src="'+videoSrc+'" title="'+photo.altText+'" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe></div>'
                };
            }
            else
                return {
                    src: photo.dataset.original,
                    download_src: photo.dataset.original,
                    high_src: photo.dataset.max,
                    w: window.innerWidth,
                    h: window.innerHeight,
                    index
                };
        });

        const options = {
            index: photoIndex,
            downloadEl: true,
            zoomEl: false,
            shareEl: true,
            getDoubleTapZoom: function(isMouseClick, item) {
                if(isMouseClick) {
                    gallery.shout("mouseZoom", item);
                    item.resized = true;
                    return 3; //<---- This 4
                } else {
                    return item.initialZoomLevel < 0.7 ? 3 : 2; //<---- 4 here
                }
            },
            tapToToggleControls: false
        };

        if (tv)
        {
            options.shareButtons = [];
        }
        else
        {
            options.shareButtons = [
                {id:'download', label:'Download', url:'{{raw_image_url}}', download:true}
            ];
        }

        const gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, photos, options);

        gallery.listen("mouseZoom", function(item) {
            if (!item.resized) {
                photos[item.index].src = item.high_src;

                // Update gallery content.
                gallery.invalidateCurrItems();
                gallery.updateSize(true);
            }
        });
        
        gallery.listen("close", function(e) {
            $("body").removeClass("noScroll");
            $(".pswp__zoom-wrap .video").html('');
        })
        

        // Image loaded
        gallery.listen('imageLoadComplete', function(index, item) {                 
            $("body").addClass("noScroll");
        });

        gallery.init();
    }
    

    $('#canvas').hide();
    
    $('.coverPage').on('click', function(e)
    {
        initGallery(0, 0);
    });

    $('.dia').on('click', function(e)
    {
        e.preventDefault();
        var dia = $(this).data('dia');
        initGallery(dia, 0);
        return false;
    });
}